import { render, staticRenderFns } from "./bingli_edit.vue?vue&type=template&id=4f03a114&scoped=true&"
import script from "./bingli_edit.vue?vue&type=script&lang=js&"
export * from "./bingli_edit.vue?vue&type=script&lang=js&"
import style0 from "./bingli_edit.vue?vue&type=style&index=0&id=4f03a114&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03a114",
  null
  
)

export default component.exports